import CasinoTV from "../../components/CasinoTV.jsx";
import React, { useEffect } from "react";
import {
  getCasinoExposureAPI,
  getUniversalCasinoLastResultAPI,
  getUniversalCasinoOddsAPI,
  uniCasinoBetAPI,
} from "../../service/casino/index.js";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import {
  getUniversalCasinoPlExposureByRunner,
  getUniversalCasinoPrePlExposureByRunner,
  GetUniversalLastTenResult,
  UNIVERSAL_EXTRA_CARDS,
} from "./genericFunctions.jsx";
import PlaceBetUniversal from "./PlaceBetUniversal.jsx";
import GenericCasinoTimer from "../../components/GenericCasinoTimer.jsx";

export default function GenericBackOnlyDistributedCasino() {
  const { id: GAME_ID } = useParams();
  const haveModule2 = GAME_ID?.includes("LUCKY_7_A");
  const haveCardSuit = GAME_ID?.includes("LUCKY_7_A");
  const [odds, setOdds] = React.useState({});
  const [lastResult, setLastResult] = React.useState({});
  const [exposure, setExposure] = React.useState({});
  const [showCustomElement, setShowCustomElement] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [timer, setTimer] = React.useState(0);
  const [showWinnerOverlay, setShowWinnerOverlay] = React.useState(false);
  const [placeBetPayload, setPlaceBetPayload] = React.useState({
    amount: 0,
    back: 0,
    casinoGames: GAME_ID,
    marketId: "",
    runnerName: "",
    marketIdWithSelectionId: "",
    type: "back",
  });
  const roundIdRef = React.useRef();

  // Function to check time condition
  const checkTimeCondition = () => {
    const timeA = new Date().getTime();
    const roundWinnerUpdatedAt = odds?.roundWinnerUpdatedAt
      ? new Date(odds.roundWinnerUpdatedAt).getTime()
      : 0;

    if (timeA < roundWinnerUpdatedAt + 3000 && timeA >= roundWinnerUpdatedAt) {
      setShowWinnerOverlay(true);
    } else {
      setShowWinnerOverlay(false);
    }
  };

  const getOdds = async () => {
    const { response } = await getUniversalCasinoOddsAPI(GAME_ID);
    setOdds(response);
  };
  const getLastResult = async () => {
    const { response } = await getUniversalCasinoLastResultAPI(GAME_ID);
    setLastResult(response);
  };
  const getExposure = async () => {
    const { response } = await getCasinoExposureAPI(roundIdRef.current);
    setExposure(response);
  };
  useEffect(() => {
    roundIdRef.current = odds?.roundId;
    setTimer(odds?.seconds);
    let interval = setInterval(() => {
      if (odds?.status == "SUSPEND" || timer <= 0) {
        setTimer(0);
      } else {
        setTimer((prev) => prev - 1);
      }
    }, 1000);

    // Add interval for time condition check
    let timeCheckInterval = setInterval(checkTimeCondition, 100);

    return () => {
      clearInterval(interval);
      clearInterval(timeCheckInterval);
    };
  }, [odds?.roundId, odds?.roundWinnerUpdatedAt]);
  const placeBet = async (marketIdWithSelectionId, runnerName, back) => {
    let payload = { ...placeBetPayload };
    payload.marketIdWithSelectionId = `${marketIdWithSelectionId}`;
    payload.runnerName = runnerName;
    payload.back = back;
    payload.marketId = odds?.roundId;
    payload.amount = 100;
    payload.type = "back";
    payload.casinoGames = GAME_ID;
    setPlaceBetPayload(payload);
  };
  const placeBetCallApi = async () => {
    setLoading(true);
    const { response, code, status } = await uniCasinoBetAPI(placeBetPayload);
    if (code === 200) {
      toast.success(status);
      getOdds();
      setPlaceBetPayload(null);
    } else {
      toast.error(response);
    }
    setLoading(false);
  };
  React.useEffect(() => {
    getOdds();
    getLastResult();
    let interval = setInterval(() => {
      getOdds();
    }, 800);
    let interval2 = setInterval(() => {
      getLastResult();
    }, 5000);
    let interval3 = setInterval(() => {
      getExposure();
    }, 2000);
    return () => {
      clearInterval(interval);
      clearInterval(interval2);
      clearInterval(interval3);
    };
  }, []);

  return (
    <div>
      <app-casino-room _ngcontent-ng-c663229740="" _nghost-ng-c2733776549="">
        <div
          _ngcontent-ng-c2733776549=""
          _ngcontent-ysg-c0=""
          id="playerInfo"
          className="top"
        >
          <div
            _ngcontent-ng-c2733776549=""
            _ngcontent-ysg-c0=""
            className="left_list"
          />
          <div
            _ngcontent-ng-c2733776549=""
            _ngcontent-ysg-c0=""
            className="right_list none-lobby-page hasTimer"
          >
            <ol _ngcontent-ng-c2733776549="" _ngcontent-ysg-c0="">
              <li _ngcontent-ng-c2733776549="" style={{ cursor: "pointer" }}>
                <i
                  _ngcontent-ng-c2733776549=""
                  _ngcontent-cuc-c0=""
                  className="fa fa-cog fa-lg"
                />
              </li>
            </ol>
          </div>
        </div>
        <div
          _ngcontent-ng-c2733776549=""
          id="stackbetsModal"
          aria-labelledby="stackbetsModal"
          aria-hidden="true"
          className="modal fade"
        >
          <div _ngcontent-ng-c2733776549="" className="modal-dialog">
            <div _ngcontent-ng-c2733776549="" className="modal-content">
              <div _ngcontent-ng-c2733776549="" className="modal-header">
                <h3 _ngcontent-ng-c2733776549="" className="mb-0 bold">
                  Stake
                </h3>
              </div>
              <div _ngcontent-ng-c2733776549="" className="stack-modal-body">
                <div
                  _ngcontent-ng-c2733776549=""
                  className="card-body container-fluid container-fluid-5 button-value quick-stake-container"
                >
                  <div
                    _ngcontent-ng-c2733776549=""
                    className="row row5 mb-1 desktop-pl"
                  >
                    <div _ngcontent-ng-c2733776549="" className="col-3">
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="button-title"
                        style={{ fontSize: 14, marginLeft: "-2px" }}
                      >
                        <span _ngcontent-ng-c2733776549="">
                          <b
                            _ngcontent-ng-c2733776549=""
                            className="stake-amount"
                          >
                            Quick Stakes
                          </b>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    _ngcontent-ng-c2733776549=""
                    className="row row5 mb-1 col-md-12 desktop-pl quick-stake-boxes"
                  >
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks0"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks1"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks2"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks3"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks4"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks5"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks6"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks7"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div _ngcontent-ng-c2733776549="" className="modal-footer">
                  <button _ngcontent-ng-c2733776549="" className="updatebtn">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </app-casino-room>
      <router-outlet _ngcontent-ng-c663229740="" />
      <app-teenpatti _nghost-ng-c2991413133="">
        <div _ngcontent-ng-c2991413133="" style={{ overflowY: "hidden" }}>
          <div _ngcontent-ng-c2991413133="">
            <app-video-player
              _ngcontent-ng-c2991413133=""
              _nghost-ng-c595356512=""
            >
              <div _ngcontent-ng-c595356512="" className="videoPlayer">
                <CasinoTV casinoGames={GAME_ID} />

                <div _ngcontent-ng-c595356512="" className="video-overlay">
                  <div _ngcontent-ng-c595356512="">
                    <div
                      _ngcontent-ng-c595356512=""
                      className="round-id text-white"
                    >
                      RID: {odds?.roundId}
                    </div>

                    {odds?.playerCards?.map((player) => (
                      <div _ngcontent-ng-c595356512="">
                        <h3 _ngcontent-ng-c595356512="" className="text-white">
                          {player?.forPerson}
                        </h3>
                        <div _ngcontent-ng-c595356512="">
                          {player?.cards?.map((card) => (
                            <img
                              _ngcontent-ng-c595356512=""
                              src={`https://casino.queenexch.com/assets/cards/${card?.cardValue}.png`}
                            />
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                {showWinnerOverlay && (
                  <div _ngcontent-ng-c595356512="" className="winnerOverlay">
                    <div
                      _ngcontent-ng-c595356512=""
                      className="mini-result-new active"
                    >
                      <span _ngcontent-ng-c595356512="">
                        {" "}
                        {odds?.roundWinner} win{" "}
                      </span>
                      {/**/}
                    </div>
                    <span
                      _ngcontent-ng-c595356512=""
                      style={{ position: "absolute" }}
                    >
                      <canvas
                        _ngcontent-ng-c595356512=""
                        width="100vw"
                        height="100vh"
                      />
                    </span>
                    {/**/}
                  </div>
                )}
                <div _ngcontent-ng-c595356512="" className="winnerOverlay">
                  <div
                    _ngcontent-ng-c595356512=""
                    className="mini-result-new resultRemover"
                  ></div>
                </div>

                <div _ngcontent-ng-c595356512="" className="timer-overlay">
                  <GenericCasinoTimer
                    time={odds?.seconds}
                    status={odds?.status}
                  />
                </div>
              </div>

              <div
                _ngcontent-ng-c595356512=""
                id="rulesModal"
                tabIndex={-1}
                aria-labelledby="exampleModalLabelaexampleModalLabela"
                aria-hidden="true"
                className="modal fade"
              >
                <div
                  _ngcontent-ng-c595356512=""
                  className="modal-dialog rules-wrap"
                >
                  <div
                    _ngcontent-ng-c595356512=""
                    role="document"
                    id="rulesList___BV_modal_content_"
                    tabIndex={-1}
                    className="modal-content rules-content"
                  >
                    <header
                      _ngcontent-ng-c595356512=""
                      id="rulesList___BV_modal_header_"
                      className="rules-wrap"
                    >
                      <a _ngcontent-ng-c595356512="">
                        <h3
                          _ngcontent-ng-c595356512=""
                          id="rulesList___BV_modal_title_"
                          data-bs-toggle="modal"
                          data-bs-target="#rulesModal"
                          className="modal-title"
                        >
                          Rules
                        </h3>
                      </a>
                      <button
                        _ngcontent-ng-c595356512=""
                        type="button"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        className="close"
                      >
                        ×
                      </button>
                    </header>
                    <div
                      _ngcontent-ng-c595356512=""
                      id="rulesList___BV_modal_body_"
                      className="modal-body"
                    >
                      <div _ngcontent-ng-c595356512="" id="rulesBoxContainer" />
                    </div>
                    <div _ngcontent-ng-c595356512="">
                      <ul
                        _ngcontent-ng-c595356512=""
                        className="btn-wrap break"
                      >
                        <li _ngcontent-ng-c595356512="">
                          <a
                            _ngcontent-ng-c595356512=""
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            className="btnok"
                          >
                            OK
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </app-video-player>
          </div>
          <div
            _ngcontent-ng-c2991413133=""
            id="marketScroll"
            style={{ overflowY: "auto", height: 616 }}
            className="overflow-auto"
          >
            {odds?.markets?.map((item) => (
              <div _ngcontent-ng-c2991413133="" className="card">
                <span
                  _ngcontent-ng-c2991413133=""
                  className="btn btn-primary card-header inner-sportbook"
                >
                  <span
                    _ngcontent-ng-c2991413133=""
                    data-bs-toggle="collapse"
                    role="button"
                    aria-expanded="true"
                    aria-controls="multiCollapseExample1"
                    className="minmax"
                    data-bs-target="#multiCollapseExample9151202184454"
                  >
                    <strong _ngcontent-ng-c2991413133="">
                      {item?.marketName}
                    </strong>
                  </span>
                  <div _ngcontent-ng-c2991413133="" className="minMaxDesktop">
                    <span _ngcontent-ng-c2991413133="">
                      Min/Max: {item?.min} - {item?.max}
                    </span>
                  </div>
                  <span _ngcontent-ng-c2991413133="" className="minMaxMobile">
                    <i
                      _ngcontent-ng-c2991413133=""
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      className="fa fa-info-circle ml-2"
                      data-bs-target="#multiCollapseExample9151202184454"
                      id="#collapse129151202184454"
                    />
                    <ul
                      _ngcontent-ng-c2991413133=""
                      className="dropdown-menu icon-range min-max-info text-end tooltip-betlimit"
                      aria-labelledby="collapse129151202184454"
                    >
                      <span _ngcontent-ng-c2991413133="">
                        Min/Max: {item?.min} - {item?.max}
                      </span>
                    </ul>
                  </span>
                </span>
                <div _ngcontent-ng-c2991413133="" className="col">
                  <div
                    _ngcontent-ng-c2991413133=""
                    className="collapse multi-collapse show"
                    id="multiCollapseExample9151202184454"
                  >
                    <div
                      _ngcontent-ng-c2991413133=""
                      className="tbl-bets p-rltv sportbook-market-tbl"
                    >
                      <div
                        className={
                          haveModule2
                            ? "d-flex flex-wrap odd-row playerABgTie"
                            : "d-flex odd-row playerABgTie"
                        }
                      >
                        {item?.oddDetailsDTO
                          ?.filter((odd) => odd?.runnerName != "TIE")
                          ?.map((odd) => (
                            <>
                              <div
                                _ngcontent-ng-c4116347132=""
                                className={
                                  haveModule2
                                    ? "col-6 ps-0 pe-0 boxPlayer"
                                    : "col ps-0 pe-0 boxPlayer"
                                }
                              >
                                <div
                                  _ngcontent-ng-c4116347132=""
                                  className="pb-1"
                                >
                                  <span
                                    _ngcontent-ng-c4116347132=""
                                    className="title"
                                  >
                                    {odd?.runnerName}
                                    {odd?.runnerName === "RED" && (
                                      <span
                                        _ngcontent-ng-c2991413133=""
                                        class="red"
                                      >
                                        {" "}
                                        ♥ ♦{" "}
                                      </span>
                                    )}
                                  </span>
                                </div>
                                <div
                                  onClick={() =>
                                    placeBet(
                                      `${item?.marketId}_${odd?.selectionId}`,
                                      odd?.runnerName,
                                      odd?.back1
                                    )
                                  }
                                  _ngcontent-ng-c4116347132=""
                                  appratehighlight=""
                                  className={`back-1 oddsBox sportbook-minwidth p-rltv ${
                                    haveCardSuit
                                      ? "d-flex p-0 align-items-center text-center justify-content-center"
                                      : ""
                                  } ${
                                    placeBetPayload?.marketIdWithSelectionId ==
                                    `${item?.marketId}_${odd?.selectionId}`
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  {item?.marketName?.split(" ")[1] ==
                                    "CARD" && (
                                    <span
                                      _ngcontent-ng-c1829941365=""
                                      className="d-flex flex-column p-0 align-items-center position-absolute"
                                      style={{ left: 4 }}
                                    >
                                      {UNIVERSAL_EXTRA_CARDS[
                                        odd?.runnerName
                                      ] ? (
                                        UNIVERSAL_EXTRA_CARDS[odd?.runnerName]
                                      ) : (
                                        <img
                                          _ngcontent-ng-c1829941365=""
                                          style={{ width: 20 }}
                                          src={`https://casino.queenexch.com/assets/t10cards/${odd?.runnerName}.jpeg`}
                                        />
                                      )}
                                    </span>
                                  )}
                                  <a
                                    _ngcontent-ng-c4116347132=""
                                    className="d-flex flex-column p-0 align-items-center"
                                    style={{
                                      textDecoration: "none",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {odd?.back1}
                                    <span
                                      _ngcontent-ng-c4116347132=""
                                      className="d-flex justify-content-center"
                                      style={{ fontSize: 11, fontWeight: 400 }}
                                    >
                                      {odd?.backSize1}
                                    </span>
                                  </a>
                                </div>
                                <div
                                  _ngcontent-ng-c4116347132=""
                                  className="d-flex align-items-center p-0"
                                >
                                  {getUniversalCasinoPrePlExposureByRunner(
                                    placeBetPayload,
                                    odd?.runnerName,
                                    odd?.selectionId,
                                    item?.marketId
                                  )}
                                  {getUniversalCasinoPlExposureByRunner(
                                    exposure,
                                    odd?.runnerName
                                  )}
                                </div>
                              </div>
                            </>
                          ))}

                        {odds?.status == "SUSPEND" && (
                          <div
                            _ngcontent-ng-c2991413133=""
                            className="suspended-casino"
                          >
                            <span
                              _ngcontent-ng-c2991413133=""
                              className="stats-text"
                            >
                              Suspended
                            </span>
                          </div>
                        )}
                      </div>
                      {!haveModule2 &&
                        placeBetPayload?.marketIdWithSelectionId?.split(
                          "_"
                        )[0] == item?.marketId &&
                        placeBetPayload?.runnerName != `TIE` && (
                          <PlaceBetUniversal
                            placeBetPayload={placeBetPayload}
                            setPlaceBetPayload={setPlaceBetPayload}
                            placeBet={placeBetCallApi}
                          />
                        )}
                      {haveModule2 &&
                        placeBetPayload?.marketIdWithSelectionId?.split(
                          "_"
                        )[0] == item?.marketId &&
                        placeBetPayload?.runnerName != `TIE` && (
                          <PlaceBetUniversal
                            placeBetPayload={placeBetPayload}
                            setPlaceBetPayload={setPlaceBetPayload}
                            placeBet={placeBetCallApi}
                          />
                        )}
                      <div className="d-flex odd-row playerABgTie">
                        {item?.oddDetailsDTO
                          ?.filter((odd) => odd?.runnerName == "TIE")
                          ?.map((odd) => (
                            <>
                              <div
                                _ngcontent-ng-c4116347132=""
                                className="col ps-0 pe-0 boxPlayer"
                              >
                                <div
                                  _ngcontent-ng-c4116347132=""
                                  className="pb-1"
                                >
                                  <span
                                    _ngcontent-ng-c4116347132=""
                                    className="title"
                                  >
                                    {odd?.runnerName}
                                  </span>
                                </div>
                                <div
                                  onClick={() =>
                                    placeBet(
                                      `${item?.marketId}_${odd?.selectionId}`,
                                      odd?.runnerName,
                                      odd?.back1
                                    )
                                  }
                                  _ngcontent-ng-c4116347132=""
                                  appratehighlight=""
                                  className={`back-1 oddsBox sportbook-minwidth p-rltv ${
                                    placeBetPayload?.marketIdWithSelectionId ==
                                    `${item?.marketId}_${odd?.selectionId}`
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <a
                                    _ngcontent-ng-c4116347132=""
                                    className="d-flex flex-column p-0 align-items-center"
                                    style={{
                                      textDecoration: "none",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {odd?.back1}
                                    <span
                                      _ngcontent-ng-c4116347132=""
                                      className="d-flex justify-content-center"
                                      style={{ fontSize: 11, fontWeight: 400 }}
                                    >
                                      {odd?.backSize1}
                                    </span>
                                  </a>
                                </div>
                                <div
                                  _ngcontent-ng-c4116347132=""
                                  className="d-flex align-items-center p-0"
                                >
                                  {getUniversalCasinoPrePlExposureByRunner(
                                    placeBetPayload,
                                    odd?.runnerName,
                                    odd?.selectionId,
                                    item?.marketId
                                  )}
                                  {getUniversalCasinoPlExposureByRunner(
                                    exposure,
                                    odd?.runnerName
                                  )}
                                </div>
                              </div>
                            </>
                          ))}
                      </div>
                      {placeBetPayload?.marketIdWithSelectionId?.split(
                        "_"
                      )[0] == item?.marketId &&
                        placeBetPayload?.runnerName == `TIE` && (
                          <PlaceBetUniversal
                            placeBetPayload={placeBetPayload}
                            setPlaceBetPayload={setPlaceBetPayload}
                            placeBet={placeBetCallApi}
                          />
                        )}
                    </div>
                  </div>
                </div>
              </div>
            ))}

            <GetUniversalLastTenResult
              lastResult={lastResult}
              eventName={GAME_ID}
            />
          </div>
        </div>
      </app-teenpatti>

      {/* Add the custom element that shows based on time condition */}
      {showCustomElement && (
        <div
          className="custom-winner-overlay"
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1000,
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            padding: "20px",
            borderRadius: "10px",
            color: "white",
            textAlign: "center",
          }}
        >
          <h2>Round Winner!</h2>
          <p>Winner: {odds?.roundWinner}</p>
        </div>
      )}
    </div>
  );
}
